var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleWithShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 80.2097C62.091 80.2097 80 62.3017 80 40.2097C80 18.1197 62.091 0.209717 40 0.209717C17.908 0.209717 0 18.1197 0 40.2097C0 62.3017 17.908 80.2097 40 80.2097Z",
    fill: "#22C55E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 69.2097C56.016 69.2097 69 56.2267 69 40.2097C69 24.1947 56.016 11.2097 40 11.2097C23.983 11.2097 11 24.1947 11 40.2097C11 56.2267 23.983 69.2097 40 69.2097Z",
    fill: "#22C55E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3589 30.688C56.5305 31.8596 56.5305 33.7591 55.3589 34.9306L38.6923 51.5973C37.5207 52.7689 35.6212 52.7689 34.4496 51.5973L27.783 44.9306C26.6114 43.7591 26.6114 41.8596 27.783 40.688C28.9545 39.5164 30.854 39.5164 32.0256 40.688L36.571 45.2333L51.1163 30.688C52.2879 29.5164 54.1874 29.5164 55.3589 30.688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleWithShadow);
export default __webpack_public_path__ + "static/media/check-circle-with-shadow.f360d784e1953fe87d33741fa42c6300.svg";
export { ForwardRef as ReactComponent };